import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-full-calendar',
	templateUrl:'./FullCalendarPluginCompPage.html',
	styles: [],
	styleUrls:['./FullCalendarPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarPluginCompPage
{
	mdContent_970 = `\`\`\`java
import com.jwebmp.plugins.fullcalendar.FullCalendar;
\`\`\``;
	mdContent_971 = `\`\`\`java
FullCalendar(String id)
\`\`\``;
	mdContent_972 = `\`\`\`java
public class MyCalendar extends FullCalendar<MyCalendar> {
    public MyCalendar() {
        super("my-cal");
        getOptions().setInitialView("dayGridMonth")
            .setEditable(true)
            .setHeaderToolbar(new FullCalendarHeaderToolBarOptions()
                .setLeft("prev,next today")
                .setCenter("title")
                .setRight("dayGridMonth,timeGridWeek,listWeek"));
        setDateClickEvent(new MyDateClickHandler());
    }

    @Override
    public FullCalendarEventsList getInitialEvents() {
        var events = new FullCalendarEventsList();
        events.add(new FullCalendarEvent<>()
            .setTitle("Sprint Planning")
            .setStart(LocalDateTime.of(2026, 3, 24, 10, 0)));
        return events;
    }
}
\`\`\``;
}
